import { Icon } from "PFComponents/icon";
import { getJobTitle, ObjectWithProfileName } from "PFCore/helpers/profile";
import { useUnbiasedProfileName } from "PFCore/hooks/use_unbiased_profile_name";
import { Profile } from "PFTypes";

import { DetailsHeader } from "../details_header";

type ProfileDetailHeaderProps = {
  profile: Profile | Partial<ObjectWithProfileName> | undefined;
  subtitle?: string;
  isUnbiasedMode?: boolean;
};

const hasPositions = (profile: Profile | Partial<ObjectWithProfileName> | undefined): profile is Profile =>
  !!profile && "positions" in profile;

export const ProfileDetailHeader = ({ profile, subtitle, isUnbiasedMode }: ProfileDetailHeaderProps) => {
  const { getUnbiasedProfileName } = useUnbiasedProfileName();

  return profile ? (
    <DetailsHeader
      title={getUnbiasedProfileName(profile, isUnbiasedMode)}
      subtitle={subtitle || (hasPositions(profile) ? getJobTitle(profile) : null)}
      linkUrl={`/profiles/${profile?.id}`}
    >
      <Icon name="profile" color="paletteBlue0" />
    </DetailsHeader>
  ) : null;
};
